export default {
  blockAlerts: false,
  search: {
    isLaunch: false,
    isLoading: false,
  },
  alerts: [],
  isMiniVariant: false,
  listSecretQuestions: [
    { id: 1, question: 'Quel est le nom de votre premier chien ?' },
    { id: 2, question: 'Quel est le nom de jeune fille de votre mère ?' },
    { id: 3, question: 'Quelle est votre couleur préférée ?' },
    { id: 4, question: 'Quel est votre livre préféré ?' },
    { id: 5, question: 'Quel est votre film préféré ?' },
  ],
  listGender: [
    { V2: 'Mr', V1: '1', key: 'Monsieur' },
    { V2: 'Mme', V1: '2', key: 'Madame' },
    { V2: 'Mlle', key: 'Mademoiselle' },
  ],
  timelineFixed: false,
};
